"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BusinessPercent = BusinessPercent;
exports.BusinessProfitAvePast3YearsAmount = BusinessProfitAvePast3YearsAmount;
exports.NetBookValueAmount = NetBookValueAmount;
exports.OwnersAveSalaryPast3YearsAmount = OwnersAveSalaryPast3YearsAmount;
var _react = _interopRequireDefault(require("react"));
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _TextInputForForm = require("../Wizard/TextInputForForm");
var _BusinessValuationWizardCalc = require("./BusinessValuationWizardCalc.config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// TEXT INPUT FIELDS START HERE
function OwnersAveSalaryPast3YearsAmount(_ref) {
  var {
    errors,
    touched,
    values
  } = _ref;
  var fieldName = 'ownersAvePrior3YearsAmount';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_BusinessValuationWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Average owner's annual salary for the past three years",
    errors: errors,
    touched: touched,
    id: _BusinessValuationWizardCalc.idPrefix + fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function BusinessProfitAvePast3YearsAmount(_ref2) {
  var {
    errors,
    touched,
    values
  } = _ref2;
  var fieldName = 'businessProfitAvePrior3YearsAmount';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_BusinessValuationWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Average annual profit for the past three years",
    errors: errors,
    touched: touched,
    id: _BusinessValuationWizardCalc.idPrefix + fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}
function NetBookValueAmount(_ref3) {
  var {
    errors,
    touched,
    values
  } = _ref3;
  var fieldName = 'netBookAmount';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '000,000';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_BusinessValuationWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Net Book Value",
    errors: errors,
    touched: touched,
    id: _BusinessValuationWizardCalc.idPrefix + fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    append: false,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}

// Other Details
function BusinessPercent(_ref4) {
  var {
    errors,
    touched,
    values
  } = _ref4;
  var fieldName = 'businessPercent';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '5';
  var placeholder = '00.00';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: false,
      currencyInput: false,
      zeroAlways: false,
      allowDecimals: 2
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_BusinessValuationWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    fieldName: fieldName,
    label: "Percentage of your business that you own",
    errors: errors,
    touched: touched,
    id: _BusinessValuationWizardCalc.idPrefix + fieldName,
    values: values,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: false,
    append: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur()
  });
}